import { gql } from '@provision/graphql-client';
import { META_DATA_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import {
  BLOCKED_PHONE_NUMBER_FRAGMENT,
  BLOCKED_PHONE_NUMBER_RELATIONS,
} from './blocked-phone-number.fragments';

export const GET_BLOCKED_PHONE_NUMBER_QUERY = gql`
  query GetBlockedPhoneNumber($params: QueryParams, $skipTotalRecords: Boolean = false) {
    getBlockedPhoneNumber(queryParams: $params) {
      records {
        ...BlockedPhoneNumberFields
        ...BlockedPhoneNumberRelations
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${BLOCKED_PHONE_NUMBER_FRAGMENT}
  ${BLOCKED_PHONE_NUMBER_RELATIONS}
  ${META_DATA_QUERY_FIELDS}
`;

export const CREATE_BLOCKED_PHONE_NUMBER_QUERY = gql`
  mutation CreateBlockedPhoneNumber($data: BlockedPhoneNumberDataInput) {
    createBlockedPhoneNumber(data: $data) {
      ...BlockedPhoneNumberFields
    }
  }
  ${BLOCKED_PHONE_NUMBER_FRAGMENT}
`;

export const DELETE_BLOCKED_PHONE_NUMBER_QUERY = gql`
  mutation DeleteBlockedPhoneNumber($conditions: [ConditionInput]) {
    deleteBlockedPhoneNumber(conditions: $conditions) {
      id
    }
  }
`;
